import * as Sentry from "@sentry/react";

/**
 * Initializes Sentry with custom configurations.
 * Includes performance monitoring, session replay, and console log capture.
 */
export const initSentry = () => {
  if (import.meta.env.VITE_SENTRY_DSN && import.meta.env.VITE_SENTRY_DSN.includes('@')) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
        // Capture console.log, console.warn, and console.error as logs in Sentry
        Sentry.consoleLoggingIntegration({
          levels: ['log', 'warn', 'error'],
        }),
      ],
      // Enable logs reporting to Sentry
      enableLogs: true,
      // Local Env
      environment: import.meta.env.VITE_APP_ENV,
      // Performance Monitoring
      tracesSampleRate: 1.0,

      // Session Replay
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }
};
